// extracted by mini-css-extract-plugin
module.exports = {"cashback-container":"_1rsxMsnF5e21wqcEZW3ask","preLoaderShimmer":"_453loRT6ydxMgP3hLUe4s"};